
  <div id="productsscroll">

  </div>

<div >
    <div *ngIf="loadAppRequest" >
      <p-progressBar  class="customProgress" mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
      <br>
    </div>
    <p-panel>
      <p-header>
        <div class="ui-helper-clearfix">
            <h2>      
              <span class="ui-panel-title" style="font-size: 22px;display:inline-block;margin-top:2px;font-weight: 500;">{{appName}}</span>  
            
              <span *ngIf="pathInfo=='production'" class="badge badge-pill badge-primary">{{pathInfo}}</span>
                    
              <span *ngIf="pathInfo=='sandbox'" class="badge badge-pill badge-secondary">{{pathInfo}}</span>
          
              <button pButton type="button" label="Go To APPs" icon="pi pi-arrow-up" (click)="goToMyApp()" class="ui-button-warning" [style]="{'float':'right','margin-top':'4px'}"></button>
                
            </h2> 
          </div>
         
      </p-header>
   
    
   
      <div *ngIf="showPublicProducts" style="background-color:#f5f5f5;width:100%" class="mx-auto d-block"> 
      <p-table #dt  [columns]="productListCols" [value]="products" [style]="{width: '100%'}"  [paginator]="false" [responsive]="true" [rows]="5">
        <ng-template pTemplate="header" let-columns>
            <tr>
              <th style="width: 10%;">
                <p-checkbox  [(ngModel)]="isAllSelected"  [binary]="true" (onChange)="changeProdSelectionStatus()"></p-checkbox>        
              </th>
                <th >Product Name                 
                </th>
                <th >Version</th>
                
                <th>APIs</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr *ngIf="rowData['categories'].indexOf(displayRole) > -1">
              <td>  <p-checkbox  [(ngModel)]="rowData.isSelected" [binary]="true"></p-checkbox> </td>
              <td class="text-break">
                {{rowData['productName']}}
            </td>
                <td class="text-break">
                  {{rowData['version']}}
              </td>
                <td > <button pButton (click)="viewApis(rowData)"  class="aetna-button ui-button-raised ui-button-rounded" label="APIs"> </button></td> 
            </tr>
        </ng-template>
    </p-table>
    <br>
    <br>
  
  <div *ngIf="showSubNowButton">
    <button   pButton type="button" label="Subscribe Now"   (click)="subscribeConfirmation('default')" class="ui-button-warning" ></button>
    
  </div>
   
 
                 
    </div>
    <div class="container-fluid">
      <div class="row" >
        <div class="col-md-12" class="break-msg">
          <p-messages   class="break-msg" class="aetna-msg" [(value)] ="msgs" [closable]="false"></p-messages>
        </div> 
      </div> 
      <div class="row" >
         
          <div class="col-md-12">
                <p-progressBar  *ngIf="showSpiner" class="customProgress" mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
         </div>
          
    </div>
    </div>
    </p-panel>
    <br>
    <p-progressBar  *ngIf="finalStatusBAr" class="customProgress" mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
    <div id="subviescroll">

    </div>
   
    <div *ngIf="finalStatus">
        <div *ngFor="let pln of apisPlan">
          <div *ngIf="pln.name==displayPlanName">
            <div [hidden]="viewApisOfProduct">
              <p-panel>
                      <p-header >
                        <div class="ui-helper-clearfix" >
                          
                        <h2>      
                          <span class="ui-panel-title" style="font-size: 22px;display:inline-block;margin-top:2px;font-weight: 500;">{{selectedProduct.productName}}</span>  
            
                          <button pButton type="button" label="Go To Products" icon="pi pi-arrow-up" (click)="goToProducats()" class="ui-button-warning" [style]="{'float':'right','margin-top':'4px'}"></button>
                         </h2>
                        </div>
                    </p-header>
                    <p-table #dt  [columns]="apisPlanCols" [value]="pln.apis" [style]="{width: '100%'}"  [responsive]="true" [scrollable]="true" scrollHeight="280px" [rows]="5">
                      <ng-template pTemplate="header" let-columns>
                          <tr>
                              <th>  
                                <label for="api"> APIs</label>
                                <br>
                                <input  id="api"  pInputText type="text"
                                (input)="dt.filter($event.target.value, 'path', 'contains')" placeholder="Search"/>
                              
                              </th>
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-rowData let-columns="columns">
                          <tr *ngIf="!(rowData.path=='fhir-server-pkce-api-provider' || rowData.path=='fhir-mobile-pkce-api-provider')  ">
                            <td class="text-break">
                              {{rowData['path']}}
                          </td>
                            
                              
                          </tr>
                      </ng-template>
                  </p-table>
              </p-panel>
            </div>
          </div>
          
        </div>
     </div>   
 </div>   

 
<p-dialog [modal]="true" header="Subscribe Product" [closable]="false" [(visible)]="subsribeconfirmationPopup" [style]="{width: '50vw'}" [baseZIndex]="10000">
 <!-- <p-header>
    <div class="ui-helper-clearfix">
        <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px"><h5>Subscribe Plan</h5></span>      
      </div> 
   </p-header>-->
 
  <label class="font-weight-bold" style="font-size: 16px;"> Do you want to subscribe the Products?</label>
<p-footer>
   <button type="button" pButton icon="pi pi-check" (click)="subscribeNowMultipleProducts()" label="Yes"class="aetna-button ui-button-raised ui-button-rounded" ></button>
   <button type="button"  pButton icon="pi pi-times" (click)="subscribecancelConfirmation()" label="No" class="aetna-button ui-button-raised ui-button-rounded"></button>
</p-footer>
</p-dialog>


<p-dialog [modal]="true" [closable]="false" header="Please Wait" [(visible)]="showSpiner" [style]="{width: '50vw'}" >
        
  <div class="container-fluid" style="width:99%" >
    <div class="row" >
      <div class="col-md-5">
      </div>
      <div class="col-md-2" >
          <p-progressSpinner  [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
      </div>
      <div class="col-md-5">

      </div>
    </div> 
  </div>
</p-dialog>
